import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const HandleExportarFlujodeCajaCBO = (periodos, sucursales) => {
  const wb = XLSX.utils.book_new();

  const formatoCLP = (valor) =>
    `$${Number(valor || 0).toLocaleString("es-CL")}`;

  periodos.forEach((periodo) => {
    const data = [];

    data.push([`PERIODO: ${periodo.mes}`]);
    data.push([]);

    data.push(["INGRESOS"]);
    data.push([]);

    const tiposIngresos = Array.from(
      new Set(periodo.detalle.ingresos.map((i) => i.tipo))
    );

    tiposIngresos.forEach((tipo) => {
      const items = periodo.detalle.ingresos.filter(
        (i) => i.tipo === tipo
      );

      data.push([`Tipo: ${tipo}`]);
      data.push(["Fecha", "Sucursal", "Descripción", "Monto"]);

      let totalCategoria = 0;

      items.forEach((item) => {
        totalCategoria += Number(item.monto);

        data.push([
          item.fecha_registro
            ? new Date(item.fecha_registro).toLocaleDateString("es-CL")
            : "-",
          sucursales?.find(
            (s) => String(s.id) === String(item.branch_id)
          )?.name || "Sin sucursal",
          item.descripcion || "-",
          formatoCLP(item.monto),
        ]);
      });

      data.push(["", "", "TOTAL CATEGORÍA", formatoCLP(totalCategoria)]);
      data.push([]);
    });

    const rowTotalIngresosIndex = data.length;
    data.push([
      "",
      "",
      "TOTAL INGRESOS",
      formatoCLP(periodo.total_ingresos),
    ]);

    data.push([]);

   
    data.push(["EGRESOS"]);
    data.push([]);

    const tiposEgresos = Array.from(
      new Set(periodo.detalle.egresos.map((i) => i.tipo))
    );

    tiposEgresos.forEach((tipo) => {
      const items = periodo.detalle.egresos.filter(
        (i) => i.tipo === tipo
      );

      data.push([`Tipo: ${tipo}`]);
      data.push(["Fecha", "Sucursal", "Descripción", "Monto"]);

      let totalCategoria = 0;

      items.forEach((item) => {
        totalCategoria += Number(item.monto);

        data.push([
          item.fecha_registro
            ? new Date(item.fecha_registro).toLocaleDateString("es-CL")
            : "-",
          sucursales?.find(
            (s) => String(s.id) === String(item.branch_id)
          )?.name || "Sin sucursal",
          item.descripcion || "-",
          formatoCLP(item.monto),
        ]);
      });

      data.push(["", "", "TOTAL CATEGORÍA", formatoCLP(totalCategoria)]);
      data.push([]);
    });

    
    const rowTotalEgresosIndex = data.length;
    data.push([
      "",
      "",
      "TOTAL EGRESOS",
      formatoCLP(periodo.total_egresos),
    ]);

    data.push([]);

  
    const rowFlujoIndex = data.length;
    data.push([
      "",
      "",
      "FLUJO NETO",
      formatoCLP(periodo.flujo_caja),
    ]);

   
    const ws = XLSX.utils.aoa_to_sheet(data);

    
    ws["!cols"] = [
      { wch: 15 }, 
      { wch: 20 }, 
      { wch: 50 }, 
      { wch: 20 }, 
    ];

    // 🎨 COLORES
    const aplicarColorFila = (rowIndex, color) => {
      for (let col = 0; col < 4; col++) {
        const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: col });

        if (!ws[cellRef]) continue;

        ws[cellRef].s = {
          fill: {
            fgColor: { rgb: color },
          },
          font: {
            bold: true,
          },
        };
      }
    };

   
    aplicarColorFila(rowTotalIngresosIndex, "C6EFCE");

    
    aplicarColorFila(rowTotalEgresosIndex, "FFC7CE");

    
    aplicarColorFila(rowFlujoIndex, "FFF2CC");

    XLSX.utils.book_append_sheet(
      wb,
      ws,
      `Periodo ${periodo.mes}`
    );
  });

  const excelBuffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
    cellStyles: true, 
  });

  const blob = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });

  saveAs(blob, "Flujo_Caja_CBO.xlsx");
};